/*** IMPORTS FROM imports-loader ***/
var define = false;

// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/noop.js
// module id = 86
// module chunks = 0